import { shareAttachmentActionCreators } from '@app/components/ShareAttachmentModal/modules/shareAttachment'
import { connect } from 'react-redux'
import { ShareToolbarButton } from '../components/ShareToolbarButton'

export default connect(
  undefined,
  shareAttachmentActionCreators,
)(ShareToolbarButton)
